import { Link } from "react-router-dom";
import Header from "@/components/site/Header";
import Ticker from "@/components/site/Ticker";
import Footer from "@/components/site/Footer";
import Seo from "@/components/site/Seo";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="bg-white text-[#0a0a0a]">
      <Seo
        title="About — Universtrend"
        description="Universtrend is an editorial index of the world's most-googled things, obsessively hand-curated across 12 countries and 8 categories."
      />
      <Header />
      <Ticker />

      <section className="border-b border-black">
        <div className="mx-auto max-w-[900px] px-6 lg:px-10 py-16 lg:py-24">
          <div className="overline text-[#52525b] mb-4">About</div>
          <h1 className="font-display font-extrabold tracking-tighter leading-[0.95] text-5xl lg:text-7xl">
            A quiet index of<br /><span className="text-[#ff3b30]">human curiosity.</span>
          </h1>

          <div className="mt-12 space-y-6 text-lg leading-relaxed text-[#0a0a0a]">
            <p>
              Universtrend was born from an obsession: if <em>you are what you google</em>, then what is each country? What sits at the top of a nation&apos;s search bar at 8am on a Tuesday morning?
            </p>
            <p>
              This is not a live analytics tool. It is an <b>editorial atlas</b>: a hand-curated, obsessive reading of the words the world types when it thinks no one is watching. Twelve countries. Eight categories. Rankings you did not expect.
            </p>
            <p>
              You will find a dashboard with filters, a Higher / Lower game, and dozens of country- and category-specific pages. Everything is free to read. No signup required.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 border-l border-t border-black">
            <div className="border-r border-b border-black p-6">
              <div className="overline text-[#52525b] mb-3">Data sources</div>
              <p className="text-sm">
                The trends shown are estimates hand-curated from public research and search-volume tools. This is not a real-time Google Trends API. A living data pipeline is on the roadmap.
              </p>
            </div>
            <div className="border-r border-b border-black p-6">
              <div className="overline text-[#52525b] mb-3">Editorial philosophy</div>
              <p className="text-sm">
                Fewer, better, hand-picked. We favour interestingness over completeness. If a trend is boring, it does not deserve a slot on this page.
              </p>
            </div>
            <div className="border-r border-b border-black p-6">
              <div className="overline text-[#52525b] mb-3">Monetization</div>
              <p className="text-sm">
                We keep a single tasteful sponsored slot on the homepage and a small affiliate shelf. That is it — no popups, no autoplay, no dark patterns.
              </p>
            </div>
            <div className="border-r border-b border-black p-6">
              <div className="overline text-[#52525b] mb-3">Get in touch</div>
              <p className="text-sm">
                Questions, corrections, sponsorships, media enquiries — write to{" "}
                <a href="mailto:jdemaratte@gmail.com" data-testid="about-contact-email" className="underline hover:text-[#ff3b30]">
                  jdemaratte@gmail.com
                </a>.
              </p>
            </div>
          </div>

          <div className="mt-16 flex flex-wrap gap-3">
            <Link to="/" data-testid="about-cta-home" className="hard-shadow border border-black bg-black text-white px-6 py-3 overline">
              Open the Atlas →
            </Link>
            <Link to="/sponsor" data-testid="about-cta-sponsor" className="hard-shadow border border-black bg-white text-black px-6 py-3 overline">
              Sponsor this site
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
